import { ArmyBuilderConfig, deepMergeObjects, DEVICE$, GLOBAL_API_REQUEST_HEADERS, SettingsConfig } from 'army-builder-shared';

import { environment } from '../environments/environment';

import { API_REQUEST_HEADERS } from './global/request-headers';

import globalTranslations from './global/i18n/en.json';
import boltAction3eTranslations from './bolt-action/i18n/en.json';
import blackSeasTranslations from './black-seas/i18n/en.json';
import bloodRedSkiesTranslations from './blood-red-skies/i18n/en.json';
import k47Translations from './k47/i18n/en.json';

export const SUPPORTED_LANGUAGES = ['en'];

export class WarlordConfig implements ArmyBuilderConfig {
    apiBaseUrl: string = environment.apiBaseUrl;
    appName = 'warlord';
    environment: string;
    globalRequestHeaders: any = {
        ...GLOBAL_API_REQUEST_HEADERS,
        ...API_REQUEST_HEADERS
    };

    roles = {
        admin: 'app_admin',
        user: 'app_user'
    };

    version: string = environment.appVersion;
    paths: { statusEffectIcons: string };
    partitionUnitsByFaction = false;
    supportedLanguages = SUPPORTED_LANGUAGES;
    translationGameIds = ['global', 'bolt-action-3e', 'black-seas', 'blood-red-skies', 'k47'];

    bundledTranslations = {
        global: { en: globalTranslations },
        'bolt-action-3e': { en: boltAction3eTranslations },
        'black-seas': { en: blackSeasTranslations },
        'blood-red-skies': { en: bloodRedSkiesTranslations },
        k47: { en: deepMergeObjects(boltAction3eTranslations, k47Translations) }
    };
    settings = {
        'bolt-action-3e': {
            choose_variant_on_add: { type: 'boolean', defaultValue: true },
            show_weapon_distribution: { type: 'boolean', defaultValue: true },
            show_force_cost_on_unit_page: { type: 'boolean', defaultValue: false },
            show_supplements_in_force_list: { type: 'boolean', defaultValue: true },
            default_force_limits_enabled: { type: 'boolean', defaultValue: true },
            default_allow_compendium: { type: 'boolean', defaultValue: false },
            default_force_points_limit: {
                type: 'number',
                defaultValue: 1250,
                min: 1,
                placeholder: 'e.g. 1250'
            },
            default_order_dice_limit: {
                type: 'number',
                defaultValue: 15,
                min: 1,
                placeholder: 'e.g. 15'
            },
            default_experience: {
                type: 'select',
                defaultValue: 'regular',
                options: [
                    { label: 'Inexperienced', value: 'inexperienced' },
                    { label: 'Regular', value: 'regular' },
                    { label: 'Veteran', value: 'veteran' }
                ]
            }
        },
        k47: {
            choose_variant_on_add: { type: 'boolean', defaultValue: true },
            show_weapon_distribution: { type: 'boolean', defaultValue: true },
            show_force_cost_on_unit_page: { type: 'boolean', defaultValue: false },
            show_supplements_in_force_list: { type: 'boolean', defaultValue: true },
            default_force_limits_enabled: { type: 'boolean', defaultValue: true },
            default_allow_bolt_action_units: { type: 'boolean', defaultValue: false },
            default_force_points_limit: {
                type: 'number',
                defaultValue: 1500,
                min: 1,
                placeholder: 'e.g. 1500'
            },
            default_order_dice_limit: {
                type: 'number',
                defaultValue: 15,
                min: 1,
                placeholder: 'e.g. 15'
            },
            default_rift_dice_limit: {
                type: 'number',
                defaultValue: 10,
                min: 1,
                placeholder: 'e.g. 10'
            },
            default_experience: {
                type: 'select',
                defaultValue: 'regular',
                options: [
                    { label: 'Inexperienced', value: 'inexperienced' },
                    { label: 'Regular', value: 'regular' },
                    { label: 'Veteran', value: 'veteran' }
                ]
            }
        }
    } as SettingsConfig;

    purchaseKey = 'wEilLpUTQQwzvgtjQEoJeOiXUmCxKodJ';
    subscriptionEnabled = false;
    device$ = DEVICE$;

    enableStripePurchases = true;
    purchaseKeys = {
        apple: 'appl_COSWLzjdZDWQZPylBqLINbgqNIS',
        google: 'goog_oNsowtZEZdqoJOXUTzwFCeXZXMK',
        stripe: 'strp_dWBJhGsYtxBVfYCptGLLYMLKrLS'
    };

    loginPollTime = 1000 * 60 * 5; // check login/subscription status every 5 minutes (though if the server throws an unknown error, for instance if the user is offline, then the app assumes the most recent status is still valid)
    loginTimeout = 1000 * 60 * 60 * 24; // if the app can't reach the server for 24 hours, log the user out

    networkTimeout: number = 15000;
    revenueCatAppId = '9c52d85c';
    purchaseHandlerRedirect = '/';
}
